import { InterceptorConfig } from '../../../modules/ssFetch';
import store from '../../../store';

/**
 * Intercepts backend responses for the whoami endpoint
 * and redirects to home page if we get a 403
 * @type {{response: (res) => Promise<IResponse<any>>}}
 */
export const authRedirectInterceptor: InterceptorConfig = {
  response: async res => {
    if (res.status === 403 && res.url.includes('/accounts/whoami/')) {
      store.dispatch.user.logout();
      store.dispatch.route.go({ route: 'start' });
    }

    return res;
  },
};
